import {useCallback} from 'react';

import {IsoDateString} from '@/types/generics';
import dayjs, {Dayjs} from 'dayjs';

import {ONE_SECOND} from '@/constants';
import {createResendCooldownDate, getFormattedDate, handleCountdownTime} from '@/utils/time';

type StartCountdownProps =
  | {
      duration?: number;
      resendCooldownEnd?: never;
      countdownCallback: (remainingTime: number) => void;
    }
  | {
      duration?: never;
      resendCooldownEnd?: Dayjs | string;
      countdownCallback: (remainingTime: number) => void;
    };

type CreateCountdownProps = {
  setResendFormattedTime: (time: string) => void;
  onEndCountdown: () => void;
};

export const useResendCountdown = () => {
  const createCountdownCallback = useCallback(
    ({setResendFormattedTime, onEndCountdown}: CreateCountdownProps) => {
      return (remainingTime: number) => {
        if (remainingTime < ONE_SECOND) {
          onEndCountdown();
          return setResendFormattedTime('');
        }

        const newTimeString = getFormattedDate(remainingTime, 'MINUTE_SECONDS');
        setResendFormattedTime(newTimeString);
      };
    },
    [],
  );

  const startCountdown = useCallback(
    async ({resendCooldownEnd, duration, countdownCallback}: StartCountdownProps) => {
      let _resendCooldownEnd = duration ? createResendCooldownDate(duration) : resendCooldownEnd;
      handleCountdownTime({timeoutEnds: dayjs(_resendCooldownEnd), callback: countdownCallback});
    },
    [],
  );

  return {
    createCountdownCallback,
    startCountdown,
  };
};
